import { apiRequest } from '@/shared/api';

import type { ClaimResult, FreebetsStatus } from '../model/types';

export function fetchFreebetsStatus(): Promise<FreebetsStatus> {
  return apiRequest<FreebetsStatus>('/freebets');
}

/**
 * Заявка на выдачу. НЕ начисление: нажатие лишь открывает диплинк
 * букмекера, само право зафиксировано раньше (ГДД §4.4).
 */
export function claimFreebets(): Promise<ClaimResult> {
  return apiRequest<ClaimResult>('/freebets/claim', { method: 'POST' });
}
